import reducer from "./reducer";
export { default as RecognitionAnalysis } from "./components/index";
export { default as recognitionAnalysisReducerName } from "./constants";
export default reducer;
